/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Elbow_ExtensionInputs */

const en_us2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`triceps extension`)
};

const pt_br2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tríceps`)
};

const es_419_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tríceps`)
};

const pt_pt2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tríceps`)
};

const fr_fr2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extension triceps`)
};

const de_de2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trizepsstrecken`)
};

const it_it2_catalog_movement_elbow_extension = /** @type {(inputs: Catalog_Movement_Elbow_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tricipiti`)
};

/**
* | output |
* | --- |
* | "triceps extension" |
*
* @param {Catalog_Movement_Elbow_ExtensionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_elbow_extension = /** @type {((inputs?: Catalog_Movement_Elbow_ExtensionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Elbow_ExtensionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_elbow_extension(inputs)
	if (locale === "es-419") return es_419_catalog_movement_elbow_extension(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_elbow_extension(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_elbow_extension(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_elbow_extension(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_elbow_extension(inputs)
	return en_us2_catalog_movement_elbow_extension(inputs)
});
export { catalog_movement_elbow_extension as "catalog.movement.elbow_extension" }